export default __webpack_public_path__ + "static/media/small.d16f688a.jpg";